import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEmail2Incoming: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"email-2-incoming, request"} maskId="square-filled-radius-0-stroke-1-IconEmail2Incoming"><path d="M22 4V7.55664L21.7266 7.69629L12.2266 12.5176L12 12.6318L11.7734 12.5176L3 8.06348V19H12V20H2V4H22Z" fill="currentColor"/><path d="M19.3535 13.3535L16.707 16H23V17H16.707L19.3535 19.6465L18.6465 20.3535L14.793 16.5L18.6465 12.6465L19.3535 13.3535Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconEmail2Incoming;
